import o from "../../../../_virtual/createStyled.js";
import r from "./defaultTheme.js";
import t from "./identifier.js";
import e from "./rootShouldForwardProp.js";
const a = o({
  themeId: t,
  defaultTheme: r,
  rootShouldForwardProp: e
});
export {
  a as default,
  e as rootShouldForwardProp
};
